import { Subtitle, constants, spacing, ExpandableCard } from '@cambridgeassessment/cambridge-ui';
import styled from 'styled-components';
import Loader from '../../../../../components/Loader/Loader';

export const SummaryContainer = styled.div`
  padding: ${spacing.M};
  width: 100%;
`;

export const SummaryTitle = styled(Subtitle)`
  font-size: ${constants.XLARGE};
  margin: 0;
`;

export const BodyContainer = styled.div`
  padding: 0 ${spacing.M};
  display: flex;
  flex-direction: column;
  width: 100%;
`;

export const StyledSubtitle = styled(Subtitle)`
  padding-top: ${constants.XSMALL};
  font-size: ${constants.LARGE};
  margin: 0;
`;

export const StyledExpandableCard = styled(ExpandableCard)`
  .MuiButtonBase-root.Mui-expanded {
    border-bottom: 0;
  }
`;

export const StyledLoader = styled(Loader)`
  padding: 0 ${spacing.base} ${spacing.base} ${spacing.base};
`;

export const ComponentResubmissionToggleSpan = styled.span`
  display: flex;
  gap: ${spacing.tiny};
  align-items: center;
  margin-left: auto;
  font-weight: bold;
  font-size: ${constants.LARGE};
  padding-right: ${spacing.small};
  padding-top: ${spacing.small};
`;
